import React, { useState, useEffect } from "react";
import "./Popup.scss";
import { useStoreActions, useStoreState } from "easy-peasy";
import Fade from "@material-ui/core/Fade";
import * as conf from "../../../config";

const Popup = () => {
  const popupShow = useStoreState((state) => state.something.popupShow);
  const setPopup = useStoreActions((actions) => actions.something.setPopup);
  const [imgNumber, setImgNumber] = useState(0);

  useEffect(() => {
    setImgNumber(0);
  }, [popupShow]);

  const nextImg = () => {
    setImgNumber(imgNumber + 1);
  };

  const prevImg = () => {
    setImgNumber(imgNumber - 1);
  };

  return (
    <Fade in={popupShow != null} timeout={500}>
      <div>
        <div className="overlay" onClick={() => setPopup(null)}></div>
        {popupShow && (
          <>
            <span
              className="material-icons closeFirstPopup"
              onClick={() => setPopup(null)}
            >
              close
            </span>
            <div className="popupInner">
              <div className="pictureContainer">
                <div
                  className="picture"
                  style={{
                    backgroundImage: `url(${
                      conf.API_HOST + popupShow.img[imgNumber].url
                    })`,
                  }}
                ></div>
                {popupShow.img.length > 1 && imgNumber > 0 && (
                  <span
                    className="material-icons leftBtn"
                    onClick={() => prevImg()}
                  >
                    arrow_back_ios
                  </span>
                )}
                {popupShow.img.length > 1 &&
                  imgNumber < popupShow.img.length - 1 && (
                    <span
                      className="material-icons rghtBtn"
                      onClick={() => nextImg()}
                    >
                      arrow_forward_ios
                    </span>
                  )}
              </div>
              <div className="description">
                <div
                  className="ql-editor"
                  dangerouslySetInnerHTML={{ __html: popupShow.description }}
                ></div>
              </div>
            </div>
          </>
        )}
      </div>
    </Fade>
  );
};

export default Popup;
